module.exports = __webpack_public_path__ + "904443b5e5622e46bddc7516078c461d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/Absolute_Steuerbelastung_2017-mobile.svg
// module id = 766
// module chunks = 1